import { render, staticRenderFns } from "./PerformanceEntry.vue?vue&type=template&id=baa8d97c&scoped=true&lang=pug&"
import script from "./PerformanceEntry.vue?vue&type=script&lang=js&"
export * from "./PerformanceEntry.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceEntry.vue?vue&type=style&index=0&id=baa8d97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa8d97c",
  null
  
)

export default component.exports